const COMBINING_MARKS = /[̀-ͯ]/g;
// Letters NFD does not decompose into a base letter and a combining mark.
const UNDECOMPOSABLE_LETTERS: Record<string, string> = {ł: "l", đ: "d", ø: "o"};

const normalizeChar = (char: string): string => {
    const lower = char.toLowerCase();
    // A few characters lower-case to more than one code unit ("İ"); keep them untouched to preserve indexes.
    if (lower.length !== 1) {
        return char;
    }

    const mapped = UNDECOMPOSABLE_LETTERS[lower];
    if (mapped) {
        return mapped;
    }

    const base = lower.normalize("NFD").replace(COMBINING_MARKS, "");

    return base.length === 1 ? base : lower;
};

/**
 * Lower-cases and strips diacritics (ł → l included) character for character, so the result has the same length as
 * the input and indexes found in it point at the same characters of the original text.
 */
export const normalizeForMatch = (text: string): string => {
    let normalized = "";

    for (let index = 0; index < text.length; index++) {
        normalized += normalizeChar(text.charAt(index));
    }

    return normalized;
};
const COMBINING_MARKS = /[̀-ͯ]/g;
// Letters NFD does not decompose into a base letter and a combining mark.
const UNDECOMPOSABLE_LETTERS: Record<string, string> = {ł: "l", đ: "d", ø: "o"};

const normalizeChar = (char: string): string => {
    const lower = char.toLowerCase();
    // A few characters lower-case to more than one code unit ("İ"); keep them untouched to preserve indexes.
    if (lower.length !== 1) {
        return char;
    }

    const mapped = UNDECOMPOSABLE_LETTERS[lower];
    if (mapped) {
        return mapped;
    }

    const base = lower.normalize("NFD").replace(COMBINING_MARKS, "");

    return base.length === 1 ? base : lower;
};

/**
 * Lower-cases and strips diacritics (ł → l included) character for character, so the result has the same length as
 * the input and indexes found in it point at the same characters of the original text.
 */
export const normalizeForMatch = (text: string): string => {
    let normalized = "";

    for (let index = 0; index < text.length; index++) {
        normalized += normalizeChar(text.charAt(index));
    }

    return normalized;
};
